export enum EntryActionOperationEnum {
  AllowCreateNewEntries,
  AllowEditEntries,
  AllowArchiveEntries,
  AllowAskUserFor,
}
